module.exports = __webpack_public_path__ + "static/img/logo.f90f8c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 0